import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "@azim-crm/icons";
import styles from "./Callout.module.css";
const toneIcon = {
    info: "helpCircle",
    warning: "alertTriangle",
    danger: "shieldAlert",
    success: "check",
};
const toneRole = {
    info: "status",
    warning: "status",
    danger: "alert",
    success: "status",
};
/**
 * Nota de contexto do Azim CRM.
 * Usada em rodapés de seção, avisos de regra e mensagens de indisponibilidade.
 */
export function Callout({ tone, title, children, action }) {
    const cls = [styles.root, styles[tone]].filter(Boolean).join(" ");
    return (_jsxs("div", { className: cls, role: toneRole[tone], children: [_jsx(Icon, { name: toneIcon[tone], size: 18, className: styles.icon ?? "" }), _jsxs("div", { className: styles.body, children: [title && _jsx("p", { className: styles.title, children: title }), _jsx("div", { className: styles.message, children: children })] }), action && _jsx("div", { className: styles.action, children: action })] }));
}
//# sourceMappingURL=Callout.js.map